export const deepCopyMap = <K, V>(map: Map<K, V>): Map<K, V> => new Map(JSON.parse(JSON.stringify(Array.from(map))));
